var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBus(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 734.92 1648.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#445a70;}.cls-2{fill:#707070;}.cls-3{fill:#464444;}.cls-4{fill:#595858;}.cls-5,.cls-6{fill:#fff;}.cls-5{stroke:#989898;stroke-width:8.83px;}.cls-7{fill:#af0101;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bus_outline",
    "data-name": "bus outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_248",
    "data-name": "Rectangle 248",
    className: "cls-1",
    d: "M13.25,0H57.58A13.25,13.25,0,0,1,70.83,13.25v9.81H0V13.25A13.25,13.25,0,0,1,13.25,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_249",
    "data-name": "Rectangle 249",
    className: "cls-1",
    d: "M14.83,6.59H56A12.35,12.35,0,0,1,68.36,18.94h0A12.35,12.35,0,0,1,56,31.3H14.83A12.36,12.36,0,0,1,2.47,18.94h0A12.35,12.35,0,0,1,14.83,6.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_250",
    "data-name": "Rectangle 250",
    className: "cls-1",
    d: "M30.72,34.63h0a10.91,10.91,0,0,1,14.59,5L66.68,83.51a10.91,10.91,0,0,1-5,14.59h0a10.91,10.91,0,0,1-14.59-5L25.69,49.22A10.91,10.91,0,0,1,30.72,34.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_251",
    "data-name": "Rectangle 251",
    className: "cls-1",
    d: "M35.54,27.24h0A10.92,10.92,0,0,1,46.45,38.15v.73A10.92,10.92,0,0,1,35.54,49.79h0A10.92,10.92,0,0,1,24.62,38.88v-.73A10.92,10.92,0,0,1,35.54,27.24Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_253",
    "data-name": "Rectangle 253",
    className: "cls-1",
    x: 53.97,
    y: 79.23,
    width: 20.84,
    height: 35.39,
    rx: 10.42,
    transform: "translate(-47.8 66.02) rotate(-41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_252",
    "data-name": "Rectangle 252",
    className: "cls-1",
    d: "M75.15,78.59h0a8.71,8.71,0,0,1,8.71,8.71v21.82a8.71,8.71,0,0,1-8.71,8.71h0a8.71,8.71,0,0,1-8.71-8.71V87.3A8.71,8.71,0,0,1,75.15,78.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_263",
    "data-name": "Rectangle 263",
    className: "cls-1",
    d: "M677.57,0h44.1a13.25,13.25,0,0,1,13.25,13.25v9.86H664.31V13.25A13.26,13.26,0,0,1,677.57,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_264",
    "data-name": "Rectangle 264",
    className: "cls-1",
    d: "M678.43,6.42H720.8A12.2,12.2,0,0,1,733,18.61h0a12.2,12.2,0,0,1-12.2,12.2H678.43a12.2,12.2,0,0,1-12.19-12.2h0A12.19,12.19,0,0,1,678.43,6.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_265",
    "data-name": "Rectangle 265",
    className: "cls-1",
    d: "M673.48,98.82h0a10.91,10.91,0,0,1-5-14.59l21.36-43.85a10.92,10.92,0,0,1,14.59-5h0a10.92,10.92,0,0,1,5,14.6L688.07,93.79A10.91,10.91,0,0,1,673.48,98.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_266",
    "data-name": "Rectangle 266",
    className: "cls-1",
    d: "M699.62,50.52h0a10.9,10.9,0,0,1-10.91-10.91v-.72A10.91,10.91,0,0,1,699.62,28h0a10.91,10.91,0,0,1,10.91,10.92v.72A10.9,10.9,0,0,1,699.62,50.52Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_267",
    "data-name": "Rectangle 267",
    className: "cls-1",
    x: 653.07,
    y: 87.24,
    width: 35.39,
    height: 20.84,
    rx: 10.42,
    transform: "translate(157 539.82) rotate(-49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_268",
    "data-name": "Rectangle 268",
    className: "cls-1",
    d: "M660,118.56h0a8.71,8.71,0,0,1-8.71-8.71V88A8.71,8.71,0,0,1,660,79.32h0A8.71,8.71,0,0,1,668.71,88v21.81A8.71,8.71,0,0,1,660,118.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.66,1085.6v227.23H94.45a37.54,37.54,0,0,1-37.55-37.55V1123.15a37.54,37.54,0,0,1,37.55-37.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M679.52,1123.15v152.13a37.48,37.48,0,0,1-21.82,34.08,37,37,0,0,1-15.72,3.47H631.2V1085.6H642a37,37,0,0,1,15.72,3.47A37.48,37.48,0,0,1,679.52,1123.15Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_259",
    "data-name": "Rectangle 259"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M679.52,281.62V433.76A37.51,37.51,0,0,1,642,471.3H631.2V244.08H642a37.51,37.51,0,0,1,37.54,37.54Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_260",
    "data-name": "Rectangle 260"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.66,245V472.23H94.45A37.54,37.54,0,0,1,56.9,434.68V282.55A37.54,37.54,0,0,1,94.45,245Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_261",
    "data-name": "Rectangle 261",
    className: "cls-1",
    d: "M73.59,208.42h0a10.27,10.27,0,0,1,10.27,10.27v29.53a10.27,10.27,0,0,1-10.27,10.27h0a10.27,10.27,0,0,1-10.27-10.27V218.69A10.27,10.27,0,0,1,73.59,208.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_262",
    "data-name": "Rectangle 262",
    className: "cls-1",
    d: "M664.13,208.42h0a10.27,10.27,0,0,1,10.27,10.27v29.53a10.27,10.27,0,0,1-10.27,10.27h0a10.27,10.27,0,0,1-10.27-10.27V218.69A10.27,10.27,0,0,1,664.13,208.42Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_256",
    "data-name": "Rectangle 256"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M656.89,118a76.7,76.7,0,0,0-3.25-13.65c-.4-1.19-.84-2.38-1.3-3.55-.34-.82-.67-1.64-1-2.45a79.29,79.29,0,0,0-4.8-9.3c-.66-1.06-1.32-2.1-2-3.12l-1.06-1.54c-.72-1-1.48-2-2.23-3v0c-.37-.49-.77-1-1.17-1.46-.59-.71-1.21-1.42-1.81-2.1q-1.56-1.72-3.18-3.38a80.39,80.39,0,0,0-6.91-6.14h0c-1-.75-2-1.5-3-2.23L623.6,65c-1-.69-2.08-1.35-3.11-2s-2.08-1.24-3.16-1.81a75.22,75.22,0,0,0-12.15-5.33L604,55.48c-.38-.14-.76-.25-1.13-.36a77.5,77.5,0,0,0-22.44-3.33H153.46A77.5,77.5,0,0,0,131,55.12c-.37.11-.75.22-1.12.36l-1.22.39a75.22,75.22,0,0,0-12.15,5.33c-1.08.57-2.12,1.19-3.15,1.81s-2.08,1.32-3.12,2l-1.54,1.06c-1,.73-2,1.48-3,2.23h0a83.51,83.51,0,0,0-6.91,6.14c-.84.84-1.66,1.7-2.43,2.58-.26.27-.51.53-.75.8-1,1.15-2,2.34-3,3.56v0c-.75,1-1.5,2-2.23,3-.33.5-.69,1-1.06,1.54-.69,1-1.35,2.06-2,3.12-1.26,2.1-2.43,4.24-3.49,6.45-.84,1.72-1.61,3.49-2.34,5.3-.47,1.17-.91,2.36-1.31,3.55a78.16,78.16,0,0,0-4.06,24.76V1571.55a77.5,77.5,0,0,0,4.06,24.78c.42,1.2.84,2.39,1.31,3.54a78.57,78.57,0,0,0,5.83,11.77c.66,1,1.32,2.08,2,3.12.37.5.73,1,1.06,1.54.73,1,1.48,2,2.23,3v0q1.45,1.83,3,3.56a91.71,91.71,0,0,0,6.54,6.54c1.15,1,2.34,2,3.55,3h0c1,.75,2,1.5,3,2.23.5.33,1,.68,1.54,1.06l3.12,2a79.54,79.54,0,0,0,11.77,5.83c1.15.46,2.34.88,3.53,1.3a77.32,77.32,0,0,0,24.78,4.07H580.4a77.23,77.23,0,0,0,24.78-4.07c1.19-.42,2.39-.84,3.53-1.3a80.14,80.14,0,0,0,11.78-5.83l3.11-2c.51-.38,1-.73,1.55-1.06,1-.73,2-1.48,3-2.23h0c1.21-1,2.41-2,3.55-3a89.67,89.67,0,0,0,6.54-6.54q1.53-1.72,3-3.56v0c.75-1,1.51-2,2.23-3,.34-.51.69-1,1.06-1.54.69-1,1.35-2.08,2-3.12a79.59,79.59,0,0,0,5.84-11.77c.46-1.15.88-2.34,1.3-3.54a77.23,77.23,0,0,0,4.06-24.78V129.09A74.13,74.13,0,0,0,656.89,118ZM631.2,1571.55a50.83,50.83,0,0,1-50.8,50.8H153.46a50.85,50.85,0,0,1-50.8-50.8V129.09a50.87,50.87,0,0,1,50.8-50.8H580.4A50.84,50.84,0,0,1,631.18,128c0,.36,0,.71,0,1.06Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M640,79.93v56.54a14.87,14.87,0,0,1-.35,3.29v0a15.45,15.45,0,0,1-8.48,10.65,15.14,15.14,0,0,1-6.63,1.5H111.85a15.5,15.5,0,0,1-15.46-15.46V77c.77-.88,1.59-1.74,2.43-2.58a83.51,83.51,0,0,1,6.91-6.14h0c1-.75,2-1.5,3-2.23L110.26,65c1-.69,2.08-1.35,3.12-2s2.07-1.24,3.15-1.81h500.8c1.08.57,2.12,1.19,3.16,1.81s2.07,1.32,3.11,2l1.55,1.06c1,.73,2,1.48,3,2.23h0A80.39,80.39,0,0,1,635,74.45q1.62,1.65,3.18,3.38C638.82,78.51,639.44,79.22,640,79.93Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_255",
    "data-name": "Rectangle 255",
    className: "cls-4",
    x: 378.7,
    y: 125.67,
    width: 261.34,
    height: 40.1,
    rx: 17.67
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stering",
    className: "cls-5",
    d: "M599,125.67A60.43,60.43,0,0,0,555.6,78.29a60.17,60.17,0,0,0-32.1,0,60.38,60.38,0,0,0-43.29,47.38,58.16,58.16,0,0,0-1,10.8,59.31,59.31,0,0,0,2,15.46,58,58,0,0,0,5.59,13.85,60.34,60.34,0,0,0,105.53,0,58.68,58.68,0,0,0,5.59-13.85,59.7,59.7,0,0,0,2-15.44A58.54,58.54,0,0,0,599,125.67Zm-111.54,0a53.21,53.21,0,0,1,49.7-42.41v46.89a6.79,6.79,0,0,0-4.31,6.34,4.63,4.63,0,0,0,.05.82l-25.34,14.62-15.3,8.83a51.72,51.72,0,0,1-3.58-8.83A53,53,0,0,1,487.41,125.67Zm52.17,64.09a53.25,53.25,0,0,1-44.44-24c-.15-.22-.3-.47-.46-.71l22.75-13.14,17.78-10.27a6.78,6.78,0,0,0,8.46.24l17.38,10,23.26,13.43c-.09.13-.18.29-.29.42A53.24,53.24,0,0,1,539.58,189.76Zm47.25-28.66L571,151.93l-24.67-14.25a7.89,7.89,0,0,0,.11-1.21,6.79,6.79,0,0,0-4.31-6.32V83.26a53.39,53.39,0,0,1,49.67,42.41,52.81,52.81,0,0,1,1.11,10.82,53,53,0,0,1-6,24.61Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_516",
    "data-name": "Group 516"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_81",
    "data-name": "Ellipse 81",
    className: "cls-6",
    cx: 439.2,
    cy: 145.77,
    r: 19.88
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_82",
    "data-name": "Ellipse 82",
    className: "cls-7",
    cx: 439.2,
    cy: 145.77,
    r: 13.25
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus);
export default __webpack_public_path__ + "static/media/bus.c3356d04779c8cbe4506d07042ed0092.svg";
export { ForwardRef as ReactComponent };